(ns app.front.view.contractor-registration.search
  (:require [app.domain.contractor-registration.model :as cr-model]
            [app.front.dashboard.search :as search]
            [app.front.search-result :as search-result]
            [app.front.ui.filter-common :as filter-common]
            [app.front.ui.updated :as ui-updated]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [potpuri.core :as p]))

(defn- view [_]
  [:div.cloudpermit-page
   [search/workspace-search (<sub [:tr])]])

(defn- registration-link
  [tr {:contractor-registration/keys [id]}]
  (cc/link
    {:href       (href/href :view/contractor-registration {:cr-id id})
     :id         (str "registration-link-" id)
     :data-cy    "open-contractor-registration-btn"
     :class-name "flex h-10 bg-ui-violet-100 text-white text-center font-bold items-center hover:no-underline"}
    [:div.flex-1.text-white.uppercase (tr [:search/open-contractor-registration])]))

(defn- result-box
  [{:contractor-registration/keys [id
                                   valid-from
                                   valid-to]
    :domain/keys                  [state]
    :group/keys                   [tz]
    :keys                         [work-type-names
                                   work-type-count]
    :as                           registration}]
  (let [tr          (<sub [:tr])
        lang        (<sub [:language])
        format-date (<sub [::date-util/date-fn])]
    [:div {:class "bx--col-xs-12 bx--col-sm-12 bx--col-md-6 bx--col-xl-4 bx--col-xxl-3 mt-4"}
     (cc/tile
       {:class-name "search-result-box"}
       [:div.content-wrapper
        (cc/link
          {:href       (href/href :view/contractor-registration {:cr-id id})
           :data-cy    "contractor-registration-title-link"
           :class-name "font-bold"}
          (i18n-model/get-text (:registrant-names registration) lang))
        [:div.mt-1.mb-5
         (if (= 1 work-type-count)
           (i18n-model/get-text work-type-names lang)
           (tr [:search/multiple-work-types]))]
        [:div.smaller.mt-1
         [ui-updated/updated {:ts   (:modified registration)
                              :user (:modified-by registration)}]]
        (when valid-from
          [search-result/middle-grouping-line
           [:span (str (tr [:licence/valid-from]) ": ")]
           [:span.bold (format-date (date-util/to-tz valid-from tz))]])
        (when valid-to
          [search-result/middle-grouping-line
           [:span (str (tr [:licence/valid-to]) ": ")]
           [:span.bold (format-date (date-util/to-tz valid-to tz))]])
        [:div.mt-5 (tr [state])]]
       [registration-link tr registration])]))

(defn- registrant-cell
  [lang {:keys [registrant-names registrant]}]
  (or (i18n-model/get-text registrant-names lang)
      (i18n-model/get-text registrant lang)))

(defn- work-types-cell
  "All the trades of the registration, as one comma-separated string.

  The names of all the work types come in one flat list, so the ones of the current language are
  picked from it, with all of them as the fallback when the language is not among them."
  [lang {:keys [work-type-names]}]
  (->> (or (seq (filter #(= lang (:entity/language %)) work-type-names))
           work-type-names)
       (map :localized-string/text)
       sort
       (str/join ", ")))

(defn- list-view-cols [{:keys [tr lang val->str-fn]}]
  [[:search/name (partial registrant-cell lang) {:truncate? true}]
   [:search-filter-attribute/domain-state (comp tr vector :domain/state) {}]
   [:search/department (comp (val->str-fn :group/id) :group/id) {}]
   [:search-filter-attribute/work-type-names (partial work-types-cell lang) {:truncate? true}]])

(defn- list-view-link [{:keys [tr]}]
  {:make-href   #(href/href :view/contractor-registration {:cr-id (:contractor-registration/id %)})
   :description (tr [:search/open-contractor-registration])})

(def search-mode {:default-view                    :dashboard-search/list-view
                  :filter-condition-attributes     cr-model/dashboard-filter-condition-attributes
                  :filter-subtype                  :filter.subtype/contractor-registration
                  :feature-gated-filter-attributes {:feature-flag.id/contractor-registration-search-filters
                                                    cr-model/additional-search-filter-condition-attributes}
                  :filter-value                    (fn [attr val]
                                                     (case attr
                                                       :group/id (first val)
                                                       val))
                  :id-fn                           :contractor-registration/id
                  :list-view-cols                  list-view-cols
                  :list-view-link                  list-view-link
                  :name                            :contractor-registration
                  :remove-filter-command           :user/remove-contractor-registration-filter
                  :render-search-result            (fn [result _]
                                                     [result-box result])
                  :save-filter-command             :user/upsert-contractor-registration-filter
                  :search-command                  :contractor-registration/find
                  :search-config-command           :user/contractor-registration-search-config
                  :subtitle                        :dashboard-search/contractor-registration-instructions
                  :title                           :dashboard-search/contractor-registration-title
                  :val->str-fn                     (fn [search-config tr attribute]
                                                     (cond
                                                       (= :group/id attribute)
                                                       (fn [v]
                                                         (-> search-config
                                                             :filter-values
                                                             :group/id
                                                             (p/find-first #(= v (first %)))
                                                             second))

                                                       (= :work-type-names attribute)
                                                       identity

                                                       (contains? cr-model/date-range-filter-condition-attributes
                                                                  attribute)
                                                       (partial filter-common/date-range->str tr attribute)

                                                       :else
                                                       (comp tr vector)))})

(def search-view
  {:name        :view/contractor-registration-search
   :view        view
   :public?     false
   :controllers [{:start (fn [_]
                           (>evt [::search/init search-mode {}]))}]})
